import React, { useState } from 'react';
import axios from 'axios';

const UploadForm = () => {
  const [image, setImage] = useState(null);
  const [result, setResult] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!image) {
      alert("Please select an image");
      return;
    }

    const formData = new FormData();
    formData.append('image', image);

    try {
      const res = await axios.post('http://localhost:5000/predict', formData);
      setResult(res.data.prediction);
    } catch (err) {
      console.error("Prediction failed:", err);
      setResult("Prediction failed");
    }
  };

  return (
    <div>
      <h2>Upload Leaf Image</h2>
      <form onSubmit={handleSubmit}>
        <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
        <button type="submit">Predict</button>
      </form>
      {result && <h3>Prediction: {result}</h3>}
    </div>
  );
};

export default UploadForm;
